import React, { useState } from 'react';
import { Grid } from '@mui/material';
import parse from 'html-react-parser'
import './FAQItemStyles.css';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const FAQItem = ({title, content, isTable = false, headers = [], data = []}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="questionItem">
      <div className="questionItemTitleBox">
        <Grid container className="questionContainer">
          <Grid xs={11} item>
            <div className="questionItemTitle bold-text" onClick={() => setOpen(!open)}>
              {title}
            </div>
          </Grid>
          <Grid xs={1} item>
            <div
              className="questionItemTitleIcon"
              onClick={() => setOpen(!open)}
            >
              {open && <KeyboardArrowUpIcon />}
              {!open && <KeyboardArrowDownIcon />}
            </div>
          </Grid>
          {open && !isTable && (
            <Grid xs={12} item className="questionContent">
              <div className="questionItemContentBox">{parse(content)}</div>
            </Grid>
          )}
          {
            open && isTable && headers.length > 0 && data.length > 0 && (
            <Grid xs={12} item className="questionContent">
              <div className="questionItemContentBox">
                <table>
                  <thead>
                    <tr>
                      {
                        headers.map((header) => (
                          <th key={Math.random()}>{header}</th>
                          ))
                        }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.map((line, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <tr key={Math.random() + index}>
                          <td>{line.qty}</td>
                          {
                            line.qty === '-' ? (
                              <td><center>{line.desc}</center></td>
                            ) : (
                              <td>{line.desc}</td>
                            )
                          }
                          {
                            line.value && <td>{line.value}</td>
                          }
                          {
                            line.total && <td>{line.total}</td>
                          }
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </Grid>
            )
          }
        </Grid>
      </div>
    </div>
  );
};